import React from 'react';
import { findByText } from 'Common/Utils';
import { ClickGesture } from 'Snippets/Redundancy'

export const GettingStarted = [
	{
		message: (
			<>
				Firstly, we have to import <b>useForm</b> from <b>formydable</b>...
			</>
		),
		find(target) {
			return findByText(target, 'span:useForm')[0];
		},
	},
	{
		message: `Secondly, we will create a schema for the default registration of the fields rule...`,
		find(target) {
			return findByText(target, 'span:registerSchema')[0];
		},
	},
	{
		placement: 'right',
		message: `Then, to register the field on the schema. you must put the attribute \`name\` of the field as the key here. so formydable know which is which...`,
		find(target) {
			return findByText(target, 'span:fname')[0];
		},
	},
	{
		message: (
			<>
				And it's <b>assignment/value</b> must be an <b>object</b> that contains
				a <b>label</b> which will be use in error messages...
			</>
		),
		find(target) {
			return findByText(target, 'span:label')[0];
		},
	},
	{
		message: (
			<>
				And especially, It must contain the main use of this library the{' '}
				<b>rules</b>...
			</>
		),
		find(target) {
			return findByText(target, 'span:rules')[0];
		},
		onNext() {
			if (!localStorage.getItem('f-rules')) {
				localStorage.setItem('f-rules', '1');
			}
			return true;
		},
	},
	{
		message: (
			<>
				When the registry is all set. we can now register the schema in{' '}
				<b>useForm</b> hooks...
			</>
		),
		find(target) {
			return findByText(target, 'span:registerSchema')[1];
		},
	},
	{
		message: (
			<>
				And then, the <b>useForm</b> will return <b>formState</b>,{' '}
				<b>formUpdate</b>, <b>formSubmit</b>, and <b>formRegistry</b>. but for
				now we only use <b>formState</b> and <b>formUpdate</b>...
			</>
		),
		find(target) {
			return findByText(target, 'span:formState')[0];
		},
	},
	{
		message: (
			<>
				The <b>formState</b> is use to fetch the updated field state in the
				schema. you can also fetch singularity by passing the name of the field.
				<br />
				<b>e.g. const fname = formState("fname")</b>
			</>
		),
		find(target) {
			return findByText(target, 'span:formState')[1];
		},
	},
	{
		message: `Then, it will return the fields state...`,
		find(target) {
			return findByText(target, 'span:fname')[1];
		},
	},
	{
		message: (
			<>
				Each field state contains the following properties: <br />
				<b>isInvalid</b>: it will be <b>true</b> if the field inputs doesn't
				matched the rules requirement
				<br />
				<b>message</b>: it will provide a message of the failed rule.
				<br />
				<b>failedIn</b>: it will provide which rule the user have failed in.
				<br />
				<b>isValidated</b>: it will be <b>true</b> if the input field has been
				validated or touched by the user
				<br />
				<b>value</b>: it will provide the field updated value.
				<br />
			</>
		),
		placement: 'bottom-right',
		find(target) {
			return findByText(target, 'span:fname')[4];
		},
	},
	{
		message: `For the effectiveness of giving a proper error message. you must check first if the field is invalid`,
		find(target) {
			return findByText(target, 'span:isInvalid')[0];
		},
	},
	{
		message: `Then, If it is truly invalid we will render the message`,
		find(target) {
			return findByText(target, 'span:message')[0];
		},
	},
	{
		message: (
			<>
				<b>Well done!!</b> Now, We must try the result!
			</>
		),
		find(target) {
			return target.querySelector('input');
		},
		onDone() {
			localStorage.getItem('f-gstar') || localStorage.setItem('f-gstar', '1');
		},
		isDoneOnClick: true,
		gesture: <ClickGesture />,
		background: {
			backdropStyle: { opacity: 1 },
			highlightStyle: { backgroundColor: 'rgba(255,255,255, 1)' },
		},
	},
];

// note
// rules validation order is from left to right. it will validate firstly the one on the left side which is the most priority. commonly "required" rule.
//
